import { useEffect, useRef } from 'react';

/**
 * Puts the keyboard focus back on the button that opened a dialog once it closes (the phone
 * menu sheet), so keyboard and screen-reader users carry on where they were.
 *
 * @param {boolean} isOpen whether the dialog is open
 * @param {Object} targetRef a ref to the button that opens it
 */
const useFocusReturn = (isOpen, targetRef) => {
  const wasOpen = useRef(isOpen);
  useEffect(() => {
    if (wasOpen.current && !isOpen && targetRef.current) {
      targetRef.current.focus();
    }
    wasOpen.current = isOpen;
  }, [isOpen, targetRef]);
};

export default useFocusReturn;
